import AddOnCollection from './AddOnCollection';

export default AddOnCollection;
